import { useTranslation } from 'react-i18next';
import LegalDocumentPage from '@/components/legal/LegalDocumentPage';
import { TERMS_SECTIONS } from '@/lib/legal/documentSections';
import { resolveLegalLocale } from '@/lib/legal/resolveLegalLocale';
import termsEn from '@/data/terms-of-use.en.md?raw';
import termsPt from '@/data/terms-of-use.md?raw';

const TERMS_MARKDOWN = {
  pt: termsPt,
  en: termsEn,
} as const;

const TermsOfUse = () => {
  const { t, i18n } = useTranslation();
  const locale = resolveLegalLocale(i18n.language);

  return (
    <LegalDocumentPage
      title={t('legalPage.terms.title')}
      subtitle={t('legalPage.terms.subtitle')}
      updatedAt="22/09/2025"
      sections={TERMS_SECTIONS[locale]}
      markdownContent={TERMS_MARKDOWN[locale]}
      companion={{ to: '/privacy', label: t('legalPage.privacy.title') }}
    />
  );
};

export default TermsOfUse;
